export default __webpack_public_path__ + "static/media/currency-icon-border-round.b9984955.svg";